import React from 'react'
import { Checkbox, Icon, Tag, Dropdown, Menu } from 'antd'
import { useTranslation } from 'react-i18next'
import AdCardHolder from '../styles/adCardStyle'

const TYPE_ICON = {
  image: 'picture',
  video: 'video-camera',
}

const STATUS_COLOR = {
  available: 'green',
  'in-use': 'blue',
  unavailable: 'red',
}

const AdCard = ({ ad, viewMode = 'grid', selected, onToggleSelect, onPreview, menuItems }) => {
  const { t } = useTranslation()

  const overlay = menuItems ? (
    <Menu>
      {menuItems.map((item) => (
        <Menu.Item key={item.key} disabled={item.disabled} onClick={item.disabled ? undefined : item.onClick}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  ) : null

  return (
    <AdCardHolder className={viewMode === 'list' ? 'list-view' : 'grid-view'}>
      <div
        className={`thumbnail${onPreview ? ' clickable' : ''}`}
        onClick={() => onPreview && onPreview()}
        role={onPreview ? 'button' : undefined}
      >
        <Checkbox
          className="select-checkbox"
          checked={selected}
          onChange={onToggleSelect}
          onClick={(e) => e.stopPropagation()}
        />
        <Icon
          type={TYPE_ICON[ad.type] || 'file'}
          className="type-icon"
        />
        {ad.thumbnail && <img src={ad.thumbnail} alt={ad.name} />}
      </div>

      <div className="info">
        <div className="title-row">
          <span className="name">{ad.name}</span>
          {overlay && (
            <Dropdown overlay={overlay} trigger={['click']}>
              <Icon type="more" className="menu-icon" />
            </Dropdown>
          )}
        </div>
        <div className="meta">
          <span className="type">{t(ad.type === 'video' ? 'Video' : 'Image')}</span>
          <span className="date">{ad.date}</span>
        </div>
      </div>
    </AdCardHolder>
  )
}

export default AdCard
